import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { parseUser } from "../../utils/storedUser";
import { dashboardFor } from "./roleRouting";

const mapStateToProps = (state) => {
    return {
        user: state?.Authentication?.user,
        token: state?.Authentication?.token,
    };
};


export const UserRoute = ({ children, ...props }) => {
    const token = props?.token || localStorage.getItem("Token");
    const rawUser = props?.user || localStorage.getItem("User");
    // parseUser never throws, so the old try/catch around it is gone.
    const parsedUser = parseUser(rawUser);
    const role = parsedUser?.role;

    return (
        <Route
            {...props}
            render={({ location }) =>
                token && role === 'user' ? (
                    children
                ) : !token ? (
                    <Redirect to={{ pathname: "/" }} />
                ) : (
                    <Redirect to={{ pathname: dashboardFor(role), state: { from: location } }} />
                )
            }
        />
    );
};

export default connect(mapStateToProps)(UserRoute);